import newCenario from "@/data/newCenario";

export default {
  namespaced: true,
  state: {
    id: null,
    faixaEl: null,
    cenario: null,
    cenarios: [],
    loading: false,
    error: null
  },
  mutations: {
    setLoading: (state, loading) => (state.loading = loading),
    setError: (state, error) => (state.error = error),
    setFaixas: (state, faixas) => (state.faixas = faixas),
    setFaixa: (state, faixa) => (state.faixa = faixa),
    //setCenarios: (state, cenarios) => (state.cenarios = cenarios),
    setCenarios (state, cenarios) {
      //processar novamente os cenarios para corrigir o key_grupo
      cenarios.forEach(c => {
        let key_grupo_novo = 0;
        c.operadoras.forEach(o => {
          o.grupos.forEach(g => {
            g.key_grupo = key_grupo_novo;
            g.planos.forEach(p => {
              //p.key_plano = 0;
              p.key_grupo = key_grupo_novo;
              key_grupo_novo++;
            })
          })
        });
      });
      state.cenarios = cenarios
    },
    setCenario: (state, cenario) => (state.cenario = cenario),
    setId: (state, id) => (state.id = id),
    setFaixaEl: (state, faixaEl) => state.faixaEl = faixaEl
  },
  actions: {
    ["resetRedes"](context) {

      let cenario = context.state.cenario,
        cenarios = context.state.cenarios;
      if (cenario) {
        cenario.redes = [];
        context.commit("setCenario", cenario);

        cenarios.forEach(c => {
          c.redes = [];
        });
        context.commit("setCenarios", cenarios);
      }
    },
    ["resetRegioes"](context) {

      let cenario = context.state.cenario,
        cenarios = context.state.cenarios;
      if (cenario) {
        cenario.regioes = [];
        context.commit("setCenario", cenario);

        cenarios.forEach(c => {
          c.regioes = [];
        });
        context.commit("setCenarios", cenarios);
      }
    },
    ["updateFaixaEl"](context, faixaEl) {

      context.commit("setFaixaEl", faixaEl);
    },
    ["updateId"](context, { id }) {

      context.commit("setId", id);
    },
    ["updateCenarios"](context, cenarios) {

      context.commit("setCenarios", cenarios);
    },
    ["updateRedes"](context, redes) {

      let cenario = context.state.cenario,
        cenarios = context.state.cenarios;
      if (cenario) {
        cenario.redes = _.union(cenario.redes, redes);
        context.commit("setCenario", cenario);

        cenarios.forEach(c => {
          c.redes = _.union(c.redes, redes);
        });
        context.commit("setCenarios", cenarios);

      }
    },
    ["updateRegioes"](context, regioes) {

      let cenario = context.state.cenario,
        cenarios = context.state.cenarios;
      if (cenario) {
        cenario.regioes = regioes;
        context.commit("setCenario", cenario);

        cenarios.forEach(c => {
          c.regioes = regioes;
        });
        context.commit("setCenarios", cenarios);
      }
    },
    ["recuperaCenario"](context, { id }) {

      let cenarios = context.state.cenarios || [],
        cenario = cenarios.find(cenario => cenario.id == id),
        lastId = cenarios.length
          ? cenarios.map(c => c.id).reduce((a, b) => Math.max(a, b))
          : 0;
      cenario = cenario ? cenario : JSON.parse(JSON.stringify(newCenario));
      lastId++
      if (cenario.nome.trim() == 'Grupo') {
        cenario.nome = `${cenario.nome} ${lastId}`
      }
      context.commit("setCenario", cenario);
    },
    ["atualizaCenarios"](context, { id, cenario }) {

      try {

        context.commit("setLoading", true);
        let cenarios = context.state.cenarios || [],
          lastId = cenarios.length
            ? cenarios.map(c => c.id).reduce((a, b) => Math.max(a, b))
            : 0,
          findIndex = cenarios.findIndex(c => c.id == id),
          index = findIndex != -1 ? findIndex : 0;
        cenario.updatedAt = new Date().getTime();
        cenario.vidas = cenario.faixas
          .map(f => f.value)
          .reduce((o, c) => parseInt(o) + parseInt(c));
        if (cenario.hasOwnProperty("id")) {
          // Atualização
          cenarios[index] = cenario;
        } else {
          // Novo cenario
          lastId++;
          cenario.id = lastId;

          if (cenarios.length > 0) {
            let operadoras = [];
            cenarios[0].operadoras.forEach(operadora => {
              let grupos = [];
              operadora.filtros.faixas = cenario.faixas;
              operadora.grupos.forEach((grupo, key_grupo) => {
                let planos = [];
                grupo.planos.forEach((plano, key_plano) => {
                  planos.push({
                    key_cenario: lastId,
                    key_operadora: parseInt(operadora.id),
                    key_grupo: key_grupo,
                    key_plano: key_plano,
                    id: plano.id,
                    rede_id: plano.rede_id,
                    admin_id: plano.hasOwnProperty('admin_id') ? plano.admin_id : null,
                    admin_nome: plano.hasOwnProperty('admin_nome') ? plano.admin_nome : null,
                    entidade_id: plano.hasOwnProperty('entidade_id') ? plano.entidade_id : null,
                    entidade_nome: plano.hasOwnProperty('entidade_nome') ? plano.entidade_nome : null,
                    nome: plano.nome,
                    compulsorio: grupo.compulsorio,
                    coparticipacao: grupo.coparticipacao,
                    coparticipacao_porcentagem: grupo.coparticipacao_porcentagem,
                    contratacao: plano.contratacao,
                    acomodacao: plano.acomodacao,
                    regras_aceitacao: plano.regras_aceitacao,
                    ordem: plano.ordem,
                    subordem: plano.subordem,
                    odonto: plano.odonto,
                    obstetricia: plano.obstetricia,
                    reembolso: plano.reembolso,
                    atuacao: plano.atuacao,
                    modalidade: plano.modalidade,
                    valores: JSON.parse(JSON.stringify(plano.valores)),
                    mei: plano.mei,
                    calculo: {
                      faixas: Object.fromEntries(
                        cenario.faixas.map(f => [f.slug, Number(f.value)])
                      ),
                      total: plano.calculo.total,
                      total_iof: plano.calculo.total_iof || 0.00,
                      vidas: cenario.vidas,
                      detalhe: plano.calculo.detalhe
                    },
                    checked: plano.checked,
                    alertas: plano.alertas,
                    taxas: plano.taxas,
                    produto: plano.produto,
                    filtros: operadora.filtros,
                  });
                })
                grupos.push({
                  key_cenario: lastId,
                  key_operadora: parseInt(operadora.id),
                  key_grupo: key_grupo,
                  id: grupo.id,
                  nome: grupo.nome,
                  compulsorio: grupo.compulsorio,
                  coparticipacao: grupo.coparticipacao,
                  min_vidas: grupo.min_vidas,
                  max_vidas: grupo.max_vidas,
                  data_inicio: grupo.data_inicio,
                  data_fim: grupo.data_fim,
                  planos: planos,
                  redes: grupo.redes,
                  odonto: grupo.odonto,
                  obstetricia: grupo.obstetricia,
                  reembolso: grupo.reembolso,
                  oper: JSON.parse(JSON.stringify(grupo.oper)),
                  oper_mae: JSON.parse(JSON.stringify(grupo.oper_mae)),
                  oper_avo: JSON.parse(JSON.stringify(grupo.oper_avo)),
                  fields: JSON.parse(JSON.stringify(grupo.fields)),
                  items: JSON.parse(JSON.stringify(grupo.items)),
                  mei: grupo.mei
                });
              });
              operadoras.push({
                key_cenario: lastId,
                id: parseInt(operadora.id),
                nome: operadora.nome,
                info_arquivos: operadora.info_arquivos,
                logotipo: operadora.logotipo,
                logotipoavo: operadora.logotipoavo,
                cor: operadora.cor,
                filtros: operadora.filtros,
                grupos: grupos,
                regioes: JSON.parse(JSON.stringify(operadora.regioes))
              });
            });

            cenario.redes = cenarios[0].redes;
            cenario.regioes = cenarios[0].regioes;
            cenario.operadoras = operadoras;
          }

          cenarios.push(cenario);
        }
        context.commit("setCenarios", cenarios);
      } catch (error) {
        context.commit("setError", error);
      } finally {
        context.commit("setLoading", false);
      }

    },
    ["atualizaPlanos"](context, { grupos, operadora, plano, produto, filtros }) {


      try {
        context.commit("setLoading", true);
        let cenarios = JSON.parse(JSON.stringify(context.state.cenarios));
        let grupoClone = JSON.parse(JSON.stringify(grupos));
        let cenarioId = context.state.cenario.hasOwnProperty('id') ? context.state.cenario.id : null;
        let operadoraId = operadora.hasOwnProperty('id') ? parseInt(operadora.id) : null;
        let planoId = plano.hasOwnProperty('id') ? plano.id : null;



        // Planos dos grupos selecionados
        let grupoFiltro = grupoClone
          .map(group => {
            group.planos = group.planos
              .map(plano => {
                plano.compulsorio = group.compulsorio;
                plano.coparticipacao = group.coparticipacao;
                plano.coparticipacao_porcentagem = group.coparticipacao_porcentagem;
                plano.mei = group.mei;
                plano.alertas = plano.hasOwnProperty('alertas')
                  ? JSON.parse(JSON.stringify(plano.alertas))
                  : [];
                plano.taxas = plano.hasOwnProperty('taxas')
                  ? JSON.parse(JSON.stringify(plano.taxas)) : {
                    descricao: "",
                    iof: false
                  };
                plano.produto = JSON.parse(JSON.stringify(produto));
                plano.filtros = JSON.parse(JSON.stringify(filtros));
                return plano;
              })
              .filter(plano => plano.checked == true);
            return group;
          })
          .filter(group => group.planos.length > 0);
          //console.log("grupo filtro:", grupoFiltro)

        // Verifica se existe cenários e se foi marcado algum plano
        if (cenarios.length > 0 && grupoFiltro.length > 0) {
          // Percorre os cenarios
          cenarios.forEach(cenario => {
            // Verifica se já existe a operadora
            let operadoraSelecionada = cenario.operadoras.find(operadora => {
              return operadora.id == operadoraId
                && operadora.filtros.tipo_plano == operadora.filtros.tipo_plano
                && operadora.filtros.contratacao == operadora.filtros.contratacao
            });
            if (cenario.id == cenarioId && operadoraSelecionada && planoId) {
              let key_grupo = plano.key_grupo,
                key_plano = plano.key_plano,
                key_cenario = plano.key_cenario;
              let novoGrupo = grupoFiltro[0],
                novoPlano = novoGrupo.planos[0];

              let gruposAtuais = JSON.parse(JSON.stringify(operadoraSelecionada.grupos));

              //encontrando o id do grupo para usar no array
              let grupoAtualId;
              gruposAtuais.forEach(function(g, k) {
                if(g.key_grupo == key_grupo) {
                  grupoAtualId = k;
                }
              });

              gruposAtuais[grupoAtualId].planos[key_plano] = {
                key_cenario: key_cenario,
                key_operadora: parseInt(operadora.id),
                key_grupo: key_grupo,
                key_plano: key_plano,
                id: novoPlano.id,
                rede_id: novoPlano.rede_id,
                admin_id: novoPlano.hasOwnProperty('admin_id') ? novoPlano.admin_id : null,
                admin_nome: novoPlano.hasOwnProperty('admin_nome') ? novoPlano.admin_nome : null,
                entidade_id: novoPlano.hasOwnProperty('entidade_id') ? novoPlano.entidade_id : null,
                entidade_nome: novoPlano.hasOwnProperty('entidade_nome') ? novoPlano.entidade_nome : null,
                nome: novoPlano.nome,
                compulsorio: novoPlano.compulsorio,
                coparticipacao: novoPlano.coparticipacao,
                coparticipacao_porcentagem: novoPlano.coparticipacao_porcentagem,
                contratacao: novoPlano.contratacao,
                acomodacao: novoPlano.acomodacao,
                regras_aceitacao: novoPlano.regras_aceitacao,
                ordem: novoPlano.ordem,
                subordem: novoPlano.subordem,
                odonto: novoPlano.odonto,
                obstetricia: novoPlano.obstetricia,
                reembolso: novoPlano.reembolso,
                atuacao: novoPlano.atuacao,
                modalidade: novoPlano.modalidade,
                valores: JSON.parse(JSON.stringify(novoPlano.valores)),
                mei: novoPlano.mei,
                calculo: {
                  faixas: Object.fromEntries(
                    cenario.faixas.map(f => [f.slug, Number(f.value)])
                  ),
                  total: novoPlano.calculo.total,
                  total_iof: novoPlano.calculo.total_iof || 0.00,
                  vidas: cenario.vidas,
                  detalhe: novoPlano.calculo.detalhe
                },
                checked: novoPlano.checked,
                alertas: novoPlano.alertas,
                taxas: novoPlano.taxas,
                produto: novoPlano.produto,
                filtros: operadora.filtros,
              };
              gruposAtuais[grupoAtualId] = {
                key_cenario: cenario.id,
                key_operadora: parseInt(operadora.id),
                key_grupo: key_grupo,
                id: novoGrupo.id,
                nome: novoGrupo.nome,
                compulsorio: novoGrupo.compulsorio,
                coparticipacao: novoGrupo.coparticipacao,
                min_vidas: novoGrupo.min_vidas,
                max_vidas: novoGrupo.max_vidas,
                data_inicio: novoGrupo.data_inicio,
                data_fim: novoGrupo.data_fim,
                planos: gruposAtuais[grupoAtualId].planos,
                redes: novoGrupo.redes,
                odonto: novoGrupo.odonto,
                obstetricia: novoGrupo.obstetricia,
                reembolso: novoGrupo.reembolso,
                oper: JSON.parse(JSON.stringify(novoGrupo.oper)),
                oper_mae: JSON.parse(JSON.stringify(novoGrupo.oper_mae)),
                oper_avo: JSON.parse(JSON.stringify(novoGrupo.oper_avo)),
                fields: JSON.parse(JSON.stringify(novoGrupo.fields)),
                items: JSON.parse(JSON.stringify(novoGrupo.items)),
                mei: novoGrupo.mei
              };
              operadoraSelecionada.grupos = gruposAtuais;
            } else if (planoId == null) {
              if (operadoraSelecionada) {

                operadoraSelecionada.regioes = JSON.parse(JSON.stringify(operadora.regioes))
                operadoraSelecionada.filtros.faixas = cenario.faixas;
                // Recupera os grupos atuais da operadora
                let gruposAtuais = JSON.parse(JSON.stringify(operadoraSelecionada.grupos));
                //console.log("grupos atuais: ", gruposAtuais);
                let gruposAtualizados = [];
                let lastKeyGrupo = gruposAtuais.length
                  ? gruposAtuais.map(g => g.key_grupo).reduce((a, b) => Math.max(a, b))
                  : 0;
                grupoFiltro.forEach((grupo, key_grupo) => {
                  let planos = [],
                    // Verifica se o grupo já existe
                    grupoAtualIndex = gruposAtuais.findIndex(g => g.id == grupo.id);
                  if (grupoAtualIndex != -1) {
                    planos = gruposAtuais[grupoAtualIndex].planos
                    let lastKeyPlano = planos.length
                      ? planos.map(p => p.key_plano).reduce((a, b) => Math.max(a, b))
                      : 0;
                    // Percorre os planos selecionados
                    grupo.planos.forEach((plano, key_plano) => {
                      if (!planos.find(p => p.id == plano.id)) {
                        if (planoId) {
                          let planoIndex = planos.findIndex(p => p.id == planoId)

                          planos[planoIndex] = {
                            key_cenario: cenario.id,
                            key_operadora: parseInt(operadora.id),
                            key_grupo: grupoAtualIndex,
                            key_plano: planoIndex,
                            id: plano.id,
                            rede_id: plano.rede_id,
                            admin_id: plano.hasOwnProperty('admin_id') ? plano.admin_id : null,
                            admin_nome: plano.hasOwnProperty('admin_nome') ? plano.admin_nome : null,
                            entidade_id: plano.hasOwnProperty('entidade_id') ? plano.entidade_id : null,
                            entidade_nome: plano.hasOwnProperty('entidade_nome') ? plano.entidade_nome : null,
                            nome: plano.nome,
                            compulsorio: plano.compulsorio,
                            coparticipacao: plano.coparticipacao,
                            coparticipacao_porcentagem: plano.coparticipacao_porcentagem,
                            contratacao: plano.contratacao,
                            acomodacao: plano.acomodacao,
                            regras_aceitacao: plano.regras_aceitacao,
                            ordem: plano.ordem,
                            subordem: plano.subordem,
                            odonto: plano.odonto,
                            obstetricia: plano.obstetricia,
                            reembolso: plano.reembolso,
                            atuacao: plano.atuacao,
                            modalidade: plano.modalidade,
                            valores: JSON.parse(JSON.stringify(plano.valores)),
                            mei: plano.mei,
                            calculo: {
                              faixas: Object.fromEntries(
                                cenario.faixas.map(f => [f.slug, Number(f.value)])
                              ),
                              total: plano.calculo.total,
                              total_iof: plano.calculo.total_iof || 0.00,
                              vidas: cenario.vidas,
                              detalhe: plano.calculo.detalhe
                            },
                            checked: plano.checked,
                            alertas: plano.alertas,
                            taxas: plano.taxas,
                            produto: plano.produto,
                            filtros: operadoraSelecionada.filtros,
                          }
                        } else {
                          lastKeyPlano++;

                          planos.push({
                            key_cenario: cenario.id,
                            key_operadora: parseInt(operadora.id),
                            key_grupo: lastKeyGrupo,
                            key_plano: lastKeyPlano,
                            id: plano.id,
                            rede_id: plano.rede_id,
                            admin_id: plano.hasOwnProperty('admin_id') ? plano.admin_id : null,
                            admin_nome: plano.hasOwnProperty('admin_nome') ? plano.admin_nome : null,
                            entidade_id: plano.hasOwnProperty('entidade_id') ? plano.entidade_id : null,
                            entidade_nome: plano.hasOwnProperty('entidade_nome') ? plano.entidade_nome : null,
                            nome: plano.nome,
                            compulsorio: plano.compulsorio,
                            coparticipacao: plano.coparticipacao,
                            coparticipacao_porcentagem: plano.coparticipacao_porcentagem,
                            contratacao: plano.contratacao,
                            acomodacao: plano.acomodacao,
                            regras_aceitacao: plano.regras_aceitacao,
                            ordem: plano.ordem,
                            subordem: plano.subordem,
                            odonto: plano.odonto,
                            obstetricia: plano.obstetricia,
                            reembolso: plano.reembolso,
                            atuacao: plano.atuacao,
                            modalidade: plano.modalidade,
                            valores: JSON.parse(JSON.stringify(plano.valores)),
                            mei: plano.mei,
                            calculo: {
                              faixas: Object.fromEntries(
                                cenario.faixas.map(f => [f.slug, Number(f.value)])
                              ),
                              total: plano.calculo.total,
                              total_iof: plano.calculo.total_iof || 0.00,
                              vidas: cenario.vidas,
                              detalhe: plano.calculo.detalhe
                            },
                            checked: plano.checked,
                            alertas: plano.alertas,
                            taxas: plano.taxas,
                            produto: plano.produto,
                            filtros: operadoraSelecionada.filtros,
                          });
                        }
                      }
                    });
                    gruposAtuais[grupoAtualIndex].planos = planos;
                    gruposAtualizados = gruposAtuais
                  } else {
                    gruposAtualizados = gruposAtuais

                    lastKeyGrupo++;
                    grupo.planos.forEach((plano, key_plano) => {
                      planos.push({
                        key_cenario: cenario.id,
                        key_operadora: parseInt(operadora.id),
                        key_grupo: lastKeyGrupo,
                        key_plano: key_plano,
                        id: plano.id,
                        rede_id: plano.rede_id,
                        admin_id: plano.hasOwnProperty('admin_id') ? plano.admin_id : null,
                        admin_nome: plano.hasOwnProperty('admin_nome') ? plano.admin_nome : null,
                        entidade_id: plano.hasOwnProperty('entidade_id') ? plano.entidade_id : null,
                        entidade_nome: plano.hasOwnProperty('entidade_nome') ? plano.entidade_nome : null,
                        nome: plano.nome,
                        compulsorio: plano.compulsorio,
                        coparticipacao: plano.coparticipacao,
                        coparticipacao_porcentagem: plano.coparticipacao_porcentagem,
                        contratacao: plano.contratacao,
                        acomodacao: plano.acomodacao,
                        regras_aceitacao: plano.regras_aceitacao,
                        ordem: plano.ordem,
                        subordem: plano.subordem,
                        odonto: plano.odonto,
                        obstetricia: plano.obstetricia,
                        reembolso: plano.reembolso,
                        atuacao: plano.atuacao,
                        modalidade: plano.modalidade,
                        valores: JSON.parse(JSON.stringify(plano.valores)),
                        mei: plano.mei,
                        calculo: {
                          faixas: Object.fromEntries(
                            cenario.faixas.map(f => [f.slug, Number(f.value)])
                          ),
                          total: plano.calculo.total,
                          total_iof: plano.calculo.total_iof || 0.00,
                          vidas: cenario.vidas,
                          detalhe: plano.calculo.detalhe
                        },
                        checked: plano.checked,
                        alertas: plano.alertas,
                        taxas: plano.taxas,
                        produto: plano.produto,
                        filtros: operadora.filtros,
                      });
                    })

                    gruposAtualizados.push({

                      key_cenario: cenario.id,
                      key_operadora: parseInt(operadora.id),
                      key_grupo: lastKeyGrupo,
                      id: grupo.id,
                      nome: grupo.nome,
                      compulsorio: grupo.compulsorio,
                      coparticipacao: grupo.coparticipacao,
                      min_vidas: grupo.min_vidas,
                      max_vidas: grupo.max_vidas,
                      data_inicio: grupo.data_inicio,
                      data_fim: grupo.data_fim,
                      planos: planos,
                      redes: grupo.redes,
                      odonto: grupo.odonto,
                      obstetricia: grupo.obstetricia,
                      reembolso: grupo.reembolso,
                      oper: JSON.parse(JSON.stringify(grupo.oper)),
                      oper_mae: JSON.parse(JSON.stringify(grupo.oper_mae)),
                      oper_avo: JSON.parse(JSON.stringify(grupo.oper_avo)),
                      fields: JSON.parse(JSON.stringify(grupo.fields)),
                      items: JSON.parse(JSON.stringify(grupo.items)),
                      mei: grupo.mei
                    });
                  }
                });
                operadoraSelecionada.grupos = gruposAtualizados;
              } else {
                let gruposAtualizados = [];
                operadora.filtros.faixas = cenario.faixas;
                grupoFiltro.forEach((grupo, key_grupo) => {
                  let planos = [];
                  grupo.planos.forEach((plano, key_plano) => {
                    planos.push({
                      key_cenario: cenario.id,
                      key_operadora: parseInt(operadora.id),
                      key_grupo: key_grupo,
                      key_plano: key_plano,
                      id: plano.id,
                      rede_id: plano.rede_id,
                      admin_id: plano.hasOwnProperty('admin_id') ? plano.admin_id : null,
                      admin_nome: plano.hasOwnProperty('admin_nome') ? plano.admin_nome : null,
                      entidade_id: plano.hasOwnProperty('entidade_id') ? plano.entidade_id : null,
                      entidade_nome: plano.hasOwnProperty('entidade_nome') ? plano.entidade_nome : null,
                      nome: plano.nome,
                      compulsorio: plano.compulsorio,
                      coparticipacao: plano.coparticipacao,
                      coparticipacao_porcentagem: plano.coparticipacao_porcentagem,
                      contratacao: plano.contratacao,
                      acomodacao: plano.acomodacao,
                      regras_aceitacao: plano.regras_aceitacao,
                      ordem: plano.ordem,
                      subordem: plano.subordem,
                      odonto: plano.odonto,
                      obstetricia: plano.obstetricia,
                      reembolso: plano.reembolso,
                      atuacao: plano.atuacao,
                      modalidade: plano.modalidade,
                      valores: JSON.parse(JSON.stringify(plano.valores)),
                      mei: plano.mei,
                      calculo: {
                        faixas: Object.fromEntries(
                          cenario.faixas.map(f => [f.slug, Number(f.value)])
                        ),
                        total: plano.calculo.total,
                        total_iof: plano.calculo.total_iof || 0.00,
                        vidas: cenario.vidas,
                        detalhe: plano.calculo.detalhe
                      },
                      checked: plano.checked,
                      alertas: plano.alertas,
                      taxas: plano.taxas,
                      produto: plano.produto,
                      filtros: operadora.filtros,
                    });
                  })

                  gruposAtualizados.push({
                    key_cenario: cenario.id,
                    key_operadora: parseInt(operadora.id),
                    key_grupo: key_grupo,
                    id: grupo.id,
                    nome: grupo.nome,
                    compulsorio: grupo.compulsorio,
                    coparticipacao: grupo.coparticipacao,
                    min_vidas: grupo.min_vidas,
                    max_vidas: grupo.max_vidas,
                    data_inicio: grupo.data_inicio,
                    data_fim: grupo.data_fim,
                    planos: planos,
                    redes: grupo.redes,
                    odonto: grupo.odonto,
                    obstetricia: grupo.obstetricia,
                    reembolso: grupo.reembolso,
                    oper: JSON.parse(JSON.stringify(grupo.oper)),
                    oper_mae: JSON.parse(JSON.stringify(grupo.oper_mae)),
                    oper_avo: JSON.parse(JSON.stringify(grupo.oper_avo)),
                    fields: JSON.parse(JSON.stringify(grupo.fields)),
                    items: JSON.parse(JSON.stringify(grupo.items)),
                    mei: grupo.mei
                  });
                });
                operadora.grupos = gruposAtualizados;
                cenario.operadoras.push(JSON.parse(JSON.stringify(operadora)));
              }
            }
          });
        }

        context.commit("setCenarios", cenarios);
      } catch (error) {
        context.commit("setError", error);
      } finally {
        context.commit("setLoading", false);
      }
    },
    ["removerCenario"](context, { id }) {

      let cenarios = context.state.cenarios,
        cenarioIndex = cenarios.findIndex(cenario => cenario.id == id);
      if (cenarioIndex != -1) {
        cenarios.splice(cenarioIndex, 1);
      }
      context.commit("setCenarios", cenarios);
    },
    ["removerCenarios"](context) {

      context.state.id = null;
      context.state.faixaEl = null;
      context.state.loading = false;
      context.state.error = null;
      context.commit("setCenario", null);
      context.commit("setCenarios", []);
    },
    ["removerPlanos"](context) {
      let cenarios = context.state.cenarios
      cenarios.forEach(cenario => {
        cenario.operadoras = []
      })
      context.commit("setCenarios", cenarios);
    },
    ["removerPlano"](context, { plano }) {
      let cenarios = context.state.cenarios
      let key_cenario = plano.key_cenario
      let key_operadora = plano.key_operadora
      let key_grupo = plano.key_grupo
      let key_plano = plano.key_plano

      // Remove a coluna dos grupos
      cenarios.forEach((cenario) => {
        if (cenario.id == key_cenario) {
          let redes = cenario.operadoras
            .flatMap(({ grupos }) =>
              grupos.flatMap(({ planos }) =>
                planos.map(({ rede_id }) => rede_id)
              )
            );
          redes = Array.from(new Set(redes));
          cenario.redes = redes
        }
        cenario.operadoras.forEach((operadora, operadoraIndex) => {
          if (operadora.id == key_operadora) {
            operadora.grupos.forEach((grupo, i) => {
              if (grupo.key_grupo == key_grupo) {
                let key = grupo.planos.findIndex(plano => plano.key_plano == key_plano);
                grupo.planos.splice(key, 1);
                if (grupo.planos.length == 0) {
                  operadora.grupos.splice(i, 1);
                }
              }
            })
            if (operadora.grupos.length == 0) {
              cenario.operadoras.splice(operadoraIndex, 1);
            }
          }
        })
      })

      context.commit("setCenarios", cenarios);
    }
  },
  getters: {
    getLoading: state => state.loading,
    getError: state => state.error,
    getCenarios: state => state.cenarios,
    getCenario: state => state.cenario,
    getFaixas: state => state.faixas,
    getFaixa: state => state.faixa,
    getId: state => state.id,
    getFaixaEl: state => state.faixaEl
  }
};